module.exports = __webpack_public_path__ + "static/media/caiwujizhang1.345de441.png";